<template>
    <div class="c-mapbox-filters container">
        <div class="row">
            <div class="c-mapbox-filters__controls col-12" :class="{'col-sm-8': !!$slots.filterCTA}">
                <fieldset class="form-group" v-for="(label, filter) in filters">
                    <input :id="filterId + filter.toLowerCase()" type="checkbox" :value="filter" v-model="available" @change="runFilter">
                    <label :class="'filter-' + filter.toLowerCase()" :for="filterId + filter.toLowerCase()">{{ label }}</label>
                </fieldset>
            </div>
            <slot name="filterCTA"></slot>
        </div>
    </div>
</template>
<script>
    import './_filters.scss';
    export default {
        name: "filters",
        props: {
            filters: Object,
            legend: {
                type: Boolean,
                default: true
            },
            map: Object,
            name: String,
        },
        data: function () {
            return {
                filterId: `filter-${this._uid}-`,
                available: Object.keys(this.filters)
            }
        },
        methods: {
            runFilter: function (e) {
                this.map.filterLayer(e.target.value, e.target.checked);
                GTM.fire('mbiEvent', this.name, `${e.target.checked ? 'Checked' : 'Unchecked'} Filter`, e.target.value);
            }
        },
        mounted() {

        },
    }
</script>


// WEBPACK FOOTER //
// Assets/Scripts/Components/Mapbox/filters/filters.vue